import { useSession } from '@side/next-auth/react';
import { useAgentTeam } from 'src/common/graphql/user/hooks/useAgentTeam';
import { getFullName } from 'src/common/utils/person';
import { useIdentity } from '$api-clients/hooks';

export function useUser() {
  const userId = useSession().data?.user?.id;
  const {
    data: user,
    isLoading: userIsLoading,
    error: userError,
  } = useIdentity(
    '/users/{userId}',
    userId ? { params: { path: { userId } } } : null,
  );
  const {
    team: agentTeam,
    loading: agentTeamLoading,
    error: agentTeamError,
  } = useAgentTeam();

  const email =
    user?.contacts?.find((c) => c.type === 'EMAIL' && c.primary)?.value ?? null;

  return {
    isLoading: userIsLoading || agentTeamLoading,
    error: userError ?? agentTeamError,
    firstName: user?.firstName,
    lastName: user?.lastName,
    email,
    photoUrl: user?.photoUrl,
    id: user?.legacyExternalId ?? user?.id,
    avatarUrl: user?.photoUrl,
    teamId: agentTeam?.legacyExternalId ?? agentTeam?.id,
    roles: user?.roles,
    displayName: getFullName(user?.firstName, user?.lastName),
  };
}
